// extracted by mini-css-extract-plugin
export default {"MainHeader":"MainHeader_MainHeader__dW7+w","MainHeader__wrap":"MainHeader_MainHeader__wrap__g22t9","DashboardNav":"MainHeader_DashboardNav__jcKRp"};